// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_eq-a";
export var fulfillmentFormRail = "_eq-9";
export var headerTitleRow = "_eq-c";
export var orderDetailsWrapper = "_eq-7";
export var orderLinkTrigger = "_eq-2";
export var paymentInformationGrid = "_eq-h";
export var paymentSummaryColumn = "_eq-i";
export var shipmentContainer = "_eq-b";
export var shipmentDetailsMainPane = "_eq-8";
export var shipmentNavigationCard = "_eq-5";
export var shipmentNavigationRail = "_eq-3";
export var shipmentNavigationRailHeader = "_eq-4";
export var shipmentSummaryFact = "_eq-e";
export var shipmentSummaryGrid = "_eq-d";
export var shipmentSummaryMetadataRow = "_eq-f";
export var shipmentSummaryTags = "_eq-g";
export var shipmentWorkspace = "_eq-0";
export var shipmentWorkspaceContent = "_eq-6";
export var shipmentWorkspaceHeader = "_eq-1";